import DoneIcon from "@mui/icons-material/Done";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Menu, MenuItem } from "@mui/material";
import React from "react";
import { useActivityPanel } from "../../hooks/useActivityPanel";

export type CustomerAction =
  | "viewDetails"
  | "copyId"
  | "copyName"
  | "createActivity"
  | "updateSegment";

interface ContextMenuProps {
  contextMenu: {
    mouseX: number;
    mouseY: number;
    data: { customerNo: number; workItemNo: number };
  } | null;
  onClose: () => void;
}

const ActivityLinkContextMenu: React.FC<ContextMenuProps> = ({
  contextMenu,
  onClose,
}) => {
  const { openActivity } = useActivityPanel();

  const handleOpenActivity = () => {
    if (contextMenu?.data?.workItemNo) {
      openActivity(contextMenu.data.workItemNo);
      onClose();
    }
  };

  const handleCompleteActivity = () => {
    if (contextMenu?.data?.workItemNo) {
      openActivity(contextMenu.data.workItemNo, "complete");
      onClose();
    }
  };

  return (
    <Menu
      open={contextMenu !== null}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={
        contextMenu !== null
          ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
          : undefined
      }
    >
      <MenuItem onClick={handleOpenActivity}>
        <OpenInNewIcon fontSize="small" sx={{ mr: 1 }} />
        Öppna aktivitet
      </MenuItem>
      <MenuItem onClick={handleCompleteActivity}>
        <DoneIcon fontSize="small" sx={{ mr: 1 }} />
        Slutför aktivitet
      </MenuItem>
    </Menu>
  );
};

export default ActivityLinkContextMenu;
